module.exports = __webpack_public_path__ + "static/media/logo-알고케어@3x.d55ea89d.png";